import axios from "axios";
import { apiURL } from "utils/config";
import { getAuthorizationHeaders } from "./auth";
import store from "../store";

/**
 * Returns Alerts for contracts
 * @returns {AxiosPromise}
 */

export const getStudentLessonLogs = (id) => {
  const schoolId = store.getState().user.selectedSchool?.id;
  if (!schoolId) return Promise.resolve({ data: null });
  const url = (schoolID, profileId) => `${apiURL}/school/${schoolID}/profile/${profileId}/studentLogs`;
  return axios({
    url: url(schoolId, id),
    method: "GET",
    headers: getAuthorizationHeaders(),
  });
};
